<ng-template
  [ngIf]="item.menu"
  [ngIfThen]="withMenuTmpl"
  [ngIfElse]="withoutMenuTmpl"
></ng-template>

<ng-template #withMenuTmpl>
  <div
    class="actionBtnWrapper"
    [snBadge]="item.badge?.value"
    [snSmartBadge]="item.badge?.name"
    [snBadgeColor]="item.badge?.color"
    [snBadgePositionX]="item.badge?.positionX"
    [snBadgePositionY]="item.badge?.positionY"
    [matTooltip]="item.label | t"
    [matTooltipPosition]="'below'"
    [class]="item.class"
  >
    <button
      mat-icon-button
      (click)="click($event)"
      [disabled]="item.disabled(context)"
      [matMenuTriggerFor]="menu"
    >
      <ng-template [ngTemplateOutlet]="iconTmpl"></ng-template>
    </button>
  </div>

  <mat-menu #menu="matMenu" [xPosition]="item.menu.positionX" [yPosition]="item.menu.positionY">
    <sn-menu [items]="item.menu.items" [context]="context"></sn-menu>
  </mat-menu>
</ng-template>

<ng-template #withoutMenuTmpl>
  <ng-template [ngIf]="item.route" [ngIfThen]="withRouteTmpl" [ngIfElse]="basicTmpl"></ng-template>
</ng-template>

<ng-template #withRouteTmpl>
  <div
    class="actionBtnWrapper"
    [snBadge]="item.badge?.value"
    [snSmartBadge]="item.badge?.name"
    [snBadgeColor]="item.badge?.color"
    [snBadgePositionX]="item.badge?.positionX"
    [snBadgePositionY]="item.badge?.positionY"
    [matTooltip]="item.label | t"
    [matTooltipPosition]="'below'"
    [class]="item.class"
  >
    <button
      mat-icon-button
      (click)="click($event)"
      [disabled]="item.disabled(context)"
      [routerLink]="item.route.link"
      [replaceUrl]="item.route.replaceUrl"
      [state]="item.route.state"
      [skipLocationChange]="item.route.skipLocationChange"
      [queryParams]="item.route.queryParams"
      [queryParamsHandling]="item.route.queryParamsHandling"
      [fragment]="item.route.fragment"
      [preserveFragment]="item.route.preserveFragment"
      [attr.aria-label]="item.label"
    >
      <ng-template [ngTemplateOutlet]="iconTmpl"></ng-template>
    </button>
  </div>
</ng-template>

<ng-template #basicTmpl>
  <div
    class="actionBtnWrapper"
    [snBadge]="item.badge?.value"
    [snSmartBadge]="item.badge?.name"
    [snBadgeColor]="item.badge?.color"
    [snBadgePositionX]="item.badge?.positionX"
    [snBadgePositionY]="item.badge?.positionY"
    [matTooltip]="item.label | t"
    [matTooltipPosition]="'below'"
    [class]="item.class"
  >
    <button
      mat-icon-button
      disabled
      *ngIf="!item.hidden(context)"
      (click)="click($event)"
      [disabled]="item.disabled(context)"
      [color]="item?.color"
      [attr.aria-label]="item.label"
    >
      <ng-template [ngTemplateOutlet]="iconTmpl"></ng-template>
    </button>
  </div>
</ng-template>

<ng-template #iconTmpl>
  <ng-container *ngIf="item.icon.template; else iconTemplate">
    <span [innerHTML]="item.icon.template"> </span>
  </ng-container>
  <ng-template #iconTemplate>
    <sn-icon
      [icon]="item.icon.icon"
      [fontSet]="item.icon.fontSet"
      [fontIcon]="item.icon.fontIcon"
      [size]="item.icon.size"
      [fontIconUnicode]="item.icon.fontIconUnicode"
      [svgIcon]="item.icon.svgIcon"
      [class]="item.icon.class"
    >
    </sn-icon>
  </ng-template>
</ng-template>
